/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { UpdateClearanceCaseResponseJson } from './update-clearance-case-response-json';
import { GenericClearanceCaseResult } from '../results/generic-clearance-case-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CaseDto } from '../models/case-dto';
import { ClearanceCaseDto } from '../models/clearance-case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class UpdateClearanceCaseResponse extends ResponseWithErrorGeneric<UpdateClearanceCaseResponseJson, GenericClearanceCaseResult> implements IResponseWithErrorGeneric<GenericClearanceCaseResult> {
  public caseId: string = undefined;
  public clearanceCaseId: string = undefined;
  public case: CaseDto;
  public clearanceCase: ClearanceCaseDto;

  //<custom-body>
  constructor(response: HttpResponse<UpdateClearanceCaseResponse>) {
    super(response, GenericClearanceCaseResult.Error);
    if (this.result === GenericClearanceCaseResult.Success) {
      this.clearanceCaseId = this.body.clearanceCaseId;
    }
  }
  //</custom-body>
}
